.tab {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}

.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.filters {
  display: flex;
  gap: 8px;
}

.addButton {
  margin-left: auto;
}

.filter,
.filterActive {
  min-height: 40px;
  padding: 8px 18px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  background: rgba(255, 255, 255, 0.18);
  backdrop-filter: blur(14px) saturate(140%);
  -webkit-backdrop-filter: blur(14px) saturate(140%);
  color: #fefdf6;
  font-family: var(--token-font-ui);
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition:
    background 120ms ease,
    color 120ms ease;
}

.filter:hover {
  background: rgba(255, 255, 255, 0.3);
}

.filterActive {
  background: var(--token-accent);
  color: #fefdf6;
  border-color: rgba(255, 255, 255, 0.5);
}

.empty {
  padding: 22px 26px;
  font-family: var(--token-font-body);
  color: var(--token-text-primary);
  width: 100%;
}

.empty p {
  margin: 0;
}

.empty h2 {
  margin: 0 0 8px;
  font-family: var(--token-font-display);
}

.grid {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
  display: grid;
  gap: 16px;
  /* Three-up at hub max-width, collapses gracefully — but the tracks
   * always span the full row so a single classroom card fills the
   * width instead of crunching to its 280px minimum. */
  grid-template-columns: repeat(auto-fill, minmax(min(320px, 100%), 1fr));
}

.create {
  padding: 22px 26px;
}
